var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"/","show-file-list":false,"before-upload":_vm.beforeFileUpload}},[_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }